module.exports = __webpack_public_path__ + "images/giftColorIcon-82d8174b0b4efd08904874df440a2e14.svg";